// Contenido de ejemplo (reemplazable) para Colnexx
export const COMPANY = {
  name: "Colnexx",
  legal: "Colnexx S.A.S.",
  phone: "3118662855",
  whatsapp: "573118662855", // formato internacional sin +
  whatsappDisplay: "+57 311 866 28 55",
  email: "atencionalusuario@colnexx.com",
  address: "El Carmen de Viboral, Antioquia, Colombia",
  nit: "900.000.000-1",
  hours: "Lunes a viernes 7:00 a.m. - 7:00 p.m. · Sábados 8:00 a.m. - 1:00 p.m.",
};

export const PLANS = [
  {
    id: "hogar-basico",
    name: "Hogar Básico",
    down: 200,
    up: 100,
    price: 59900,
    tag: "Ideal para navegar y redes",
    features: ["200 Mbps de descarga", "100 Mbps de carga", "Fibra óptica FTTH", "WiFi 6 incluido", "Soporte 24/7"],
    popular: false,
  },
  {
    id: "hogar-plus",
    name: "Hogar Plus",
    down: 500,
    up: 250,
    price: 79900,
    tag: "El favorito de las familias",
    features: ["500 Mbps de descarga", "250 Mbps de carga", "Fibra óptica FTTH", "WiFi 6 mesh incluido", "Router de alto rendimiento", "Soporte prioritario 24/7"],
    popular: true,
  },
  {
    id: "hogar-gamer",
    name: "Hogar Gamer",
    down: 900,
    up: 500,
    price: 109900,
    tag: "Máxima velocidad y baja latencia",
    features: ["900 Mbps de descarga", "500 Mbps de carga", "Fibra óptica simétrica", "IP fija opcional", "Prioridad de tráfico gaming", "Soporte premium dedicado"],
    popular: false,
  },
];

export const COVERAGE_ZONES = [
  { city: "Parque", status: "Disponible", coords: { x: 44, y: 55 } },
  { city: "Villas de Alejandria", status: "Disponible", coords: { x: 30, y: 61 } },
  { city: "Villa Suiza", status: "Disponible", coords: { x: 56, y: 58 } },
  { city: "Villa Maria", status: "Disponible", coords: { x: 51, y: 42 } },
  { city: "El Eden", status: "Disponible", coords: { x: 54, y: 52 } },
  { city: "El Zacatin", status: "Disponible", coords: { x: 53, y: 34 } },
  // { city: "Soacha", neighborhoods: ["Centro", "San Mateo", "Compartir"], status: "Disponible", coords: { x: 47, y: 62 } },
  // { city: "Chía", neighborhoods: ["Centro", "La Balsa"], status: "Disponible", coords: { x: 50, y: 42 } },
  // { city: "Zipaquirá", neighborhoods: ["Centro", "Algarra"], status: "Próximamente", coords: { x: 48, y: 33 } },
  // { city: "Cajicá", neighborhoods: ["Centro", "Capellanía"], status: "Disponible", coords: { x: 51, y: 38 } },
  // { city: "Facatativá", neighborhoods: ["Centro", "Cartagenita"], status: "Próximamente", coords: { x: 33, y: 55 } },
  // { city: "Girardot", neighborhoods: ["Centro"], status: "Próximamente", coords: { x: 30, y: 78 } },
  // { city: "Fusagasugá", neighborhoods: ["Centro", "Balmoral"], status: "Disponible", coords: { x: 42, y: 80 } },
];

export const QUALITY_INDICATORS = [
  { metric: "Velocidad efectiva de descarga", value: "98,4%", detail: "Porcentaje de la velocidad contratada entregada en promedio", trend: "up" },
  { metric: "Velocidad efectiva de carga", value: "97,1%", detail: "Porcentaje de la velocidad de subida contratada", trend: "up" },
  { metric: "Disponibilidad del servicio", value: "99,7%", detail: "Tiempo con servicio activo en el trimestre", trend: "stable" },
  { metric: "Latencia promedio", value: "12 ms", detail: "Tiempo de respuesta hacia servidores nacionales", trend: "down" },
  { metric: "Pérdida de paquetes", value: "0,3%", detail: "Paquetes no entregados en la red", trend: "down" },
  { metric: "Tiempo de restablecimiento", value: "3,2 h", detail: "Promedio de solución ante fallas reportadas", trend: "down" },
];

export const SPEED_FACTORS = {
  operador: [
    "Capacidad y estado de la red de acceso y transporte.",
    "Congestión en horas pico dentro de la red del operador.",
    "Configuración del nodo y del equipo terminal (ONT/Router) suministrado.",
    "Mantenimientos programados y trabajos de expansión de red.",
  ],
  externos: [
    "Cantidad de dispositivos conectados simultáneamente en el hogar.",
    "Uso de redes WiFi vs. conexión por cable (interferencia y distancia al router).",
    "Capacidad y rendimiento del equipo del usuario (computador, celular).",
    "Servidores de destino y contenido ubicados fuera del país.",
    "Uso de VPN, antivirus o aplicaciones que limitan el ancho de banda.",
    "Condiciones de la instalación interna del usuario.",
  ],
};

export const TRAFFIC_PRACTICES = [
  { title: "No bloqueo de contenido", desc: "Colnexx no bloquea, degrada ni discrimina el acceso a aplicaciones o contenidos lícitos escogidos por el usuario." },
  { title: "Gestión razonable", desc: "Aplicamos prácticas de gestión de tráfico únicamente para preservar la seguridad e integridad de la red y mitigar congestión temporal." },
  { title: "Priorización transparente", desc: "En caso de congestión, la gestión se realiza sin favorecer proveedores específicos, informando siempre al usuario." },
  { title: "Seguridad de red", desc: "Filtramos tráfico malicioso (DDoS, spam, malware) para proteger a nuestros usuarios y la infraestructura." },
];

export const TRANSPARENCY_ITEMS = [
  { tramite: "Radicación de PQR", canal: "Formulario web y WhatsApp", desde: "01/01/2025", telefono: true },
  { tramite: "Consulta de estado de PQR", canal: "Portal web / línea de atención", desde: "01/01/2025", telefono: true },
  { tramite: "Solicitud de traslado de servicio", canal: "Formulario web y WhatsApp", desde: "01/03/2025", telefono: true },
  { tramite: "Consulta y descarga de facturas", canal: "Portal de usuario", desde: "15/02/2025", telefono: true },
  { tramite: "Solicitud de cambio de plan", canal: "WhatsApp / portal web", desde: "01/04/2025", telefono: true },
  { tramite: "Terminación del contrato", canal: "Formulario web", desde: "01/05/2025", telefono: true },
];

export const PQR_TYPES = ["Petición", "Queja", "Reclamo", "Recurso"];
export const RECURSO_TYPES = ["Reposición", "Reposición y en subsidio Apelación"];
export const ID_TYPES = ["Cédula de ciudadanía", "Cédula de extranjería", "NIT", "Pasaporte"];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758687126234-89901f426283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGZhbWlseSUyMHVzaW5nJTIwbGFwdG9wJTIwbW9kZXJuJTIwaG9tZXxlbnwwfHx8fDE3ODY1NTA4MDB8MA&ixlib=rb-4.1.0&q=85",
  fiber: "https://images.unsplash.com/photo-1607723619307-260d7a1e1f12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxmaWJlciUyMG9wdGljJTIwY2FibGVzJTIwb3JhbmdlfGVufDB8fHx8MTc4NjU1MDgwMHww&ixlib=rb-4.1.0&q=85",
  support: "https://images.unsplash.com/photo-1712159018726-4564d92f3ec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjdXN0b21lciUyMHNlcnZpY2UlMjBhZ2VudCUyMG1vZGVybnxlbnwwfHx8fDE3ODY1NTA4MDF8MA&ixlib=rb-4.1.0&q=85",
  bogota: "https://images.unsplash.com/photo-1759375352933-c96abe2e4be7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxib2dvdGElMjBjb2xvbWJpYSUyMGNpdHlzY2FwZXxlbnwwfHx8fDE3ODY1NTA4MDB8MA&ixlib=rb-4.1.0&q=85",
};

export const currency = (n) => new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n);
